﻿import {
    Chart,
    LineController,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    ChartConfiguration,
    Tooltip
} from "chart.js";

Chart.register(
    LineController,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    Tooltip
);

export class ProfitableChart {

    constructor() {

    }


    build() {
        const ctx = (document.getElementById('profitable') as HTMLCanvasElement).getContext('2d');

        const config: ChartConfiguration = {
            type: 'line', // base type; line datasets will override
           
            data: {
                labels: ['mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep'],
                datasets: [
                    {
                        label: 'Avg Active Time (s)',
                        data: [4.9, 6.1, 4.7, 4.4, 4.6, 4.9, 4.2].map(e => e * 60),
                        borderColor: '#4cff00',
                        backgroundColor: 'rgba(76, 255, 0, 0.2)',
                        type: 'line',
                        yAxisID: 'y1',
                    },
                    {
                        label: 'Order Conversion Rate (%)',
                        data: [4.99, 5.19, 5.93, 5.28, 3.35, 5.77, 9.25],
                        borderColor: '#ff6a00',
                        backgroundColor: 'rgba(255, 106, 0, 0.4)',
                        type: 'line',
                        yAxisID: 'y2'
                    }
                ]
            },
            options: {
                color: '#efefef',
                responsive: true,
                interaction: { mode: 'index', intersect: false },
                //maintainAspectRatio: false,
                plugins: {
                    legend: { position: 'top' },
                    tooltip: { mode: 'index', intersect: false }
                },
                scales: {
                    y1: {
                        type: 'linear',
                        position: 'left',
                        title: { display: true, text: 'Avg Active Time (s)' }
                    },
                    y2: {
                        type: 'linear',
                        position: 'right',
                        title: { display: true, text: 'Order Conversion Rate (%)' },
                        grid: { drawOnChartArea: false }
                    }
                }
            }
        };

        new Chart(ctx, config);
    }
}